import AutocompleteInput from "../../Components/AutocompleteInput";
import { Box } from "@mui/material";

export default function TimePickerValue({ value, handleChange, options }) {
  return (
    <Box>
      <AutocompleteInput
        width={70}
        options={options}
        value={value}
        onChange={handleChange}
        variant="scheduler"
        textAlign="center"
        //error={Number.isNaN(Number(value))}
      />
    </Box>
  );
}
